import httpService from '../../http'
import api from '../../api'
import helpers from '../../helpers'
const errorsStr = helpers.error.errors
const mapper = helpers.mapper
const apiModule = api.config

function getModel () {
  return {
    admin: {
      data: 'admin',
      title: 'admin',
      value: null,
      type: null
    },
    bonus: {
      data: 'bonus',
      title: 'Бонус',
      value: null,
      type: null
    },
    programs: {
      // data: 'programs',
      // title: 'Программы',
      // value: null,
      // type: null
      '60': []
    },
    program: {
      data: 'program',
      title: 'Программа',
      value: null,
      type: null
    },
    company: {
      data: 'company',
      title: 'Информация о компании',
      value: null,
      type: null
    },
    adminEmail: {
      data: 'adminEmail',
      title: 'Адрес эл.почты для уведомлений',
      value: null,
      type: null
    }
  }
};

function role () { return localStorage.getItem('role') };

const state = {
  model: getModel(),
  config: getModel(),
  errMain: null,
  errors: {
    max: null,
    cashback: null,

    // programs: null,
    // stepPrice: null,

    phone: null,
    address: null,
    email: null,
    site: null
  }
}
const getters = {
  getOne (state) { return state.config },
  getErrors (state) { return state.errors },
  getErrMain (state) { return state.errMain }
}
const mutations = {
  setOne (state, data) { state.config = data },
  setErrors (state, data) { state.errors[data.param] = data.value },
  setErrMain (state, data) { state.errMain = data }
}
const actions = {
  resetAllErr ({ commit }) {
    commit('setErrMain', null)
    let errors = state.errors
    for (let err in errors) {
      commit('setErrors', { param: err, value: null })
    };
  },
  sendErrMain ({ commit }, data) {
    console.log(data)
    commit('setErrMain', httpService.error(data))
  },
  async get ({ state, commit, dispatch }, data) {
    try {
      dispatch('resetAllErr')
      let result = await httpService.get(apiModule[role()].get, {})
      commit('setOne', result.data)
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async update ({ state, commit, dispatch }, data) {
    try {
      let dataNew = data.data
      delete dataNew.admin
      if (!dataNew.bonus.max) commit('setErrors', { param: 'max', value: errorsStr.empty })
      if (!dataNew.bonus.cashback) commit('setErrors', { param: 'cashback', value: errorsStr.empty })
      if (!dataNew.company.phone) commit('setErrors', { param: 'phone', value: errorsStr.empty })
      if (!dataNew.company.address) commit('setErrors', { param: 'address', value: errorsStr.empty })
      if (!dataNew.company.email) commit('setErrors', { param: 'email', value: errorsStr.empty })
      if (!dataNew.company.site) commit('setErrors', { param: 'site', value: errorsStr.empty })
      let isErr = false
      for (let error in state.errors) {
        if (state.errors[error]) isErr = true
      };
      if (!isErr) {
        let result = dataNew
        result = await httpService.patch(apiModule.admin.update, dataNew)
        let resultToView = result.data
        commit('setOne', resultToView)
        dispatch('resetAllErr')
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
